export default __webpack_public_path__ + "static/media/ISEO CLASS-1 EXAM PATTERN 2025.43f68058.pdf";